<fury-page-layout mode="card">
  <fury-page-layout-header>
    <div class="top_heading">
      <fury-breadcrumbs
        [@fadeInRight]
        [current]="'Claim Status'"
      ></fury-breadcrumbs>
      <button mat-button class="can-button" (click)="redirectToDashboard()">
        <mat-icon>keyboard_backspace</mat-icon> Back
      </button>
    </div>
  </fury-page-layout-header>
  <fury-page-layout-content [@fadeInUp]>
    <div class="two_section">
      <div class="customer_leftinfo">
        <fury-customer-side-menu></fury-customer-side-menu>
      </div>

      <div class="righpanel">
        <form [formGroup]="claimStatusForm">
          <div class="field_area">
            <div
              fxLayout="column"
              fxLayout.gt-sm="row"
              fxLayoutGap.gt-sm="10px"
            >
              <div class="input_wrap">
                <div class="input_sec">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Claim Status</mat-label>
                    <mat-select matNativeControl formControlName="status">
                      <mat-option *ngFor="let status of claimStatus" [value]="status?.statusName">{{
                        status?.statusName
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div
              fxLayout="column"
              fxLayout.gt-sm="row"
              fxLayoutGap.gt-sm="10px"
            >
              <div class="input_wrap">
                <div class="input_sec">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Note</mat-label>
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="5"
                      cdkAutosizeMaxRows="5"
                      formControlName="note"
                    ></textarea>
                    <mat-error
                      *ngIf="
                        claimStatusForm.controls['note'].touched &&
                        claimStatusForm.controls['note'].hasError('required')
                      "
                    >
                      This is required field.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div
              class="actions"
              fxLayout="row"
              fxLayoutAlign="end center"
              fxLayoutGap="8px"
            >
              <button mat-button class="sub-button" (click)="changeStatus()">Save</button>
            </div>
          </div>
        </form>

        <div class="history_Prt">
          <h2>Claim Status History</h2>
          <fury-claim-status-history-table
            [displayedColumns]="displayedColumns"
            [dataSource]="dataSource"
          >
          </fury-claim-status-history-table>
          <mat-paginator
        *ngIf="this.totalCount > 0"
        [pageSizeOptions]="[30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
        </div>
      </div>
    </div>
  </fury-page-layout-content>
</fury-page-layout>
